export default __webpack_public_path__ + "static/media/peppa_george.7cf64228.png";